<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {NuxtPage} from '#components';
    import {use3rdParties, useAsyncData, useHead, useHostSettings, useHTMLAttrsLang, useScripts} from '#imports';

    use3rdParties();
    useHTMLAttrsLang();

    const {data, error} = await useAsyncData('host-settings', () => useHostSettings(), {deep: true});
    if (!error.value) {
        const {loadScripts} = useScripts(data.value);
        useHead({script: await loadScripts()});
    }
</script>
